import { QueryClient } from '@tanstack/react-query';
import { projectQueryKeys, projectMemberQueryKeys, timeEntryQueryKeys } from './queryInvalidation';

export const DATA_REFRESH_INTERVAL_MS = 5000;

const liveQueryKeys = new Set([
  ...projectQueryKeys.map(([key]) => key),
  ...projectMemberQueryKeys.map(([key]) => key),
  ...timeEntryQueryKeys.map(([key]) => key),
  'clients', 'taskTypes', 'projectRoles', 'employees', 'costTypes',
  'newProject', 'managerUsers', 'projectActivities',
]);

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnMount: 'always',
        refetchOnWindowFocus: 'always',
        refetchOnReconnect: 'always',
        // Only poll mounted server-data queries; hidden tabs catch up on focus.
        refetchInterval: (query) =>
          liveQueryKeys.has(query.queryKey[0]) ? DATA_REFRESH_INTERVAL_MS : false,
        refetchIntervalInBackground: false,
        retry: 1,
        staleTime: DATA_REFRESH_INTERVAL_MS,
      },
    },
  });
}
